import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'markdownRender' })
export class MarkdownRenderPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, isStreaming: boolean = false): SafeHtml {
    if (!text) return this.sanitizer.bypassSecurityTrustHtml('');
    const html = isStreaming ? this.renderStreaming(text) : this.renderFull(text);
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private renderStreaming(text: string): string {
    const boundaryIndex = this.findLastBlockBoundary(text);
    if (boundaryIndex === -1) {
      return `<span class="streaming-text">${this.escapeHtml(text)}<span class="scraii-ai-summary-cursor">|</span></span>`;
    }
    const complete = text.slice(0, boundaryIndex);
    const partial = text.slice(boundaryIndex).trimStart();
    const cursor = `<span class="scraii-ai-summary-cursor">|</span>`;
    const partialHtml = partial
      ? `<span class="streaming-text">${this.escapeHtml(partial)}${cursor}</span>`
      : cursor;
    return this.renderFull(complete) + partialHtml;
  }

  private findLastBlockBoundary(text: string): number {
    // Match double-newline or newline-before-hr
    const regex = /\n\n|\n(?=---)/g;
    let lastIndex = -1;
    let match: RegExpExecArray | null;
    while ((match = regex.exec(text)) !== null) {
      lastIndex = match.index + match[0].length;
    }
    return lastIndex;
  }

  private renderFull(text: string): string {
    const lines = text.split('\n');
    const blocks: string[] = [];
    let listItems: string[] = [];

    const flushList = () => {
      if (listItems.length) {
        blocks.push(`<ul>${listItems.join('')}</ul>`);
        listItems = [];
      }
    };

    for (const rawLine of lines) {
      const line = rawLine.trim();

      if (line === '---') {
        flushList();
        blocks.push('<hr>');
      } else if (line.startsWith('### ')) {
        flushList();
        blocks.push(`<h3>${this.inline(line.slice(4))}</h3>`);
      } else if (line.startsWith('## ')) {
        flushList();
        blocks.push(`<h2>${this.inline(line.slice(3))}</h2>`);
      } else if (line.startsWith('# ')) {
        flushList();
        blocks.push(`<h1>${this.inline(line.slice(2))}</h1>`);
      } else if (line.startsWith('- ')) {
        listItems.push(`<li>${this.inline(line.slice(2))}</li>`);
      } else if (line === '') {
        flushList();
      } else {
        flushList();
        blocks.push(`<p>${this.inline(line)}</p>`);
      }
    }

    flushList();
    return blocks.join('');
  }

  private inline(text: string): string {
    return this.escapeHtml(text)
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  }

  private escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}
